import { Button } from '@massilia/ui'
import { SlidersHorizontal } from 'lucide-react'

interface FiltersButtonProps {
  activeFiltersCount: number
  onClick: () => void
}

export function FiltersButton({ activeFiltersCount, onClick }: FiltersButtonProps) {
  return (
    <Button
      className="mb-4 flex w-full items-center justify-center gap-2 md:hidden"
      onClick={onClick}
      variant="outline"
    >
      <SlidersHorizontal className="h-4 w-4" />
      <span>Filtrer</span>
      {activeFiltersCount > 0 && (
        <span className="bg-brand-600 ml-1 flex h-5 w-5 items-center justify-center rounded-full text-xs text-white">
          {activeFiltersCount}
        </span>
      )}
    </Button>
  )
}
